import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const RoomChargeButtonTextWrap = styled.span`
	font-size: inherit;
	font-family: ${theme.fontRobotoMedium};
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.12em;
	width: 100%;
`
RoomChargeButtonTextWrap.displayName = 'RoomChargeButtonTextWrap'

export const RoomChargeButtonTextLabel = styled.span`
	font-size: 1em;
	font-weight: 500;
	line-height: 1.18em;
`
RoomChargeButtonTextLabel.displayName = 'RoomChargeButtonTextLabel'

export const RoomChargeButtonTextHint = styled.span`
	font-size: 0.81em;
	font-weight: 400;
	line-height: 1.18em;
	color: ${colorTheme.roomCharge.buttonHint};
`
RoomChargeButtonTextHint.displayName = 'RoomChargeButtonTextHint'
